// Delay before closePopper hands focus back to the input, giving committed state updates
// time to flush so handleFocus re-seeds from the fresh value.
export const RETURN_FOCUS_DELAY_MS = 50;
